{
  "holeCategory": {
    "production": "Production",
    "buffer": "Buffer",
    "trim": "Trim",
    "preSplit": "Pre-split",
    "toe": "Toe",
    "ramp": "Ramp",
    "pilot": "Pilot",
    "other": "Other"
  },
  "blastCategory": {
    "production": "Production",
    "ramp": "Ramp",
    "toe": "Toe",
    "trim": "Trim",
    "preSplit": "Pre-split",
    "other": "Other"
  },
  "meter": {
    "percussion": "Percussion hours",
    "compressor": "Compressor hours",
    "rotation": "Rotation hours",
    "tramming": "Tramming hours"
  },
  "actions": {
    "back": "Back",
    "post": "Post",
    "postAnyway": "Post anyway",
    "approve": "Approve",
    "reverse": "Reverse"
  },
  "shared": {
    "lotSuffix": "(lot {{lot}})",
    "reasonRequired": "Reason (required)",
    "inUse": "In use",
    "retired": "Retired",
    "editNamed": "Edit {{name}}"
  },
  "chargeQa": {
    "noDip": "{{hole}} has no dip.",
    "dipTooOld_one": "{{hole}} was last dipped {{count}} hour before charging, more than the {{limit}} hour limit.",
    "dipTooOld_other": "{{hole}} was last dipped {{count}} hours before charging, more than the {{limit}} hour limit.",
    "belowDip": "{{hole}} is charged to {{depth}} m, below the {{dipped}} m it dipped.",
    "chargeLength": "{{hole}} has {{actual}} m of charge against {{design}} m designed, outside the {{tolerance}} m tolerance.",
    "stemmingLength": "{{hole}} has {{actual}} m of stemming against {{design}} m designed, outside the {{tolerance}} m tolerance."
  },
  "holeSheet": {
    "drill": {
      "title": "Drill sheet",
      "print": "Print the drill sheet"
    },
    "dip": {
      "title": "Dip sheet",
      "print": "Print the dip sheet"
    },
    "loading": {
      "title": "Loading sheet",
      "print": "Print the loading sheet"
    },
    "nextHole": "Next hole: {{hole}}"
  },
  "holeColumn": {
    "label": "The hole's charge column"
  },
  "holePlan": {
    "noPositions": "No hole has a position yet. Import the design to draw the plan.",
    "label_one": "Plan of {{count}} hole",
    "label_other": "Plan of {{count}} holes",
    "north": "N",
    "newHole": "The new hole"
  },
  "holeWorkspace": {
    "backToPlan": "Back to the plan",
    "hideEntries": "Hide the entries",
    "showEntries": "Show the entries"
  },
  "movementFormat": {
    "fromTo": "{{from}} to {{to}}",
    "blast": "blast {{reference}}"
  },
  "openMisfire": {
    "warning": "Open misfire on {{reference}}. Do not dig near it until it has been cleared.",
    "withHoles_one": "Open misfire on {{reference}} (hole {{holes}}). Do not dig near it until it has been cleared.",
    "withHoles_other": "Open misfire on {{reference}} (holes {{holes}}). Do not dig near it until it has been cleared."
  },
  "parkedPanel": {
    "title": "Offline movements needing resolution",
    "enteredBy": "{{when}} by {{who}}",
    "posted": {
      "register": "Movement posted to the register",
      "ledger": "Movement posted to the ledger"
    },
    "discarded": "Movement discarded",
    "postTitle": "Post the movement",
    "discardTitle": "Discard the movement",
    "discardExplain": {
      "register": "It stays on record, marked discarded with your reason, and never reaches the register. Discard it when it was entered twice, or a stocktake has already counted it.",
      "ledger": "It stays on record, marked discarded with your reason, and never reaches the ledger. Discard it when it was entered twice, or a stocktake has already counted it."
    },
    "note": "Note",
    "postAnywayQuestion": "Post it anyway?"
  },
  "stocktakePanel": {
    "title": "Stocktakes waiting for approval",
    "countedBy": "counted {{when}} by {{who}}",
    "sheet": "sheet {{reference}}",
    "countLine": "{{book}} {{bookQuantity}}, counted {{counted}} {{unit}}:",
    "commentRequired": "Comment (required)"
  },
  "printSheet": {
    "loading": "Loading the {{subject}}",
    "failed": "The {{subject}} could not be loaded.",
    "downloadPdf": "Download PDF",
    "print": "Print"
  },
  "reverseModal": {
    "title": "Reverse this {{movement}}",
    "reversed": "Movement reversed"
  },
  "shiftCalendar": {
    "clear": "Clear"
  },
  "rc": {
    "selectRig": "Select RC Rig",
    "noRigs": "No RC Rigs Available",
    "noneThisShift": "{{rig}} has no RC drilling recorded this shift.",
    "start": "Start RC Drilling",
    "pitStage": "Pit stage",
    "programme": "Programme",
    "holes": "Holes",
    "metres": "Metres",
    "samples": "Samples",
    "required": "Pit stage, type, holes and metres are required",
    "lineAdded": "Line added",
    "lineSaved": "Line saved",
    "thisShift_one": "This shift: <strong>{{count}} hole, {{metres}} m</strong>",
    "thisShift_other": "This shift: <strong>{{count}} holes, {{metres}} m</strong>"
  },
  "references": {
    "tabs": {
      "bitSizes": "Bit sizes",
      "holeTypes": "Hole types",
      "blastTypes": "Blast types",
      "removalReasons": "Removal reasons",
      "monitors": "Monitors",
      "complianceLimits": "Compliance limits"
    }
  },
  "monitors": {
    "pit": "Pit",
    "wholeMine": "Whole mine",
    "make": "Make",
    "serial": "Serial",
    "calibrationDue": "Calibration due",
    "notRecorded": "Not recorded",
    "position": "Position",
    "notOnMap": "Not on the map",
    "lastReading": "Last reading",
    "add": "Add a monitor",
    "saved": "Monitor saved",
    "pitField": "Pit (blank for one that watches the whole mine)",
    "serialNumber": "Serial number",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "note": "A reading from a monitor past its calibration date is still kept, and flagged on the blast. The position puts it on the map."
  },
  "limits": {
    "measure": "Measure",
    "inForceFrom": "In force from",
    "limit": "Limit",
    "neverAbove": "Never above",
    "allowedOver": "Allowed over",
    "percentOfBlasts": "{{percent}}% of blasts",
    "judgedOver": "Judged over",
    "inForce": "In force",
    "notYetUsed": "Not yet used",
    "superseded": "Superseded",
    "intro": "Vibration and airblast limits from the site licence or EIA. A limit that has judged a blast can no longer be edited; add a new one from a later day.",
    "add": "Add a limit",
    "saved": "Limit saved",
    "editTitle": "Edit the limit",
    "limitIn": "Limit ({{unit}})",
    "neverAboveIn": "Never above ({{unit}}, optional)",
    "allowedOverField": "Blasts allowed over the limit (%)",
    "calendarYear": "The calendar year",
    "latestBlasts": "The latest blasts",
    "howManyBlasts": "How many blasts",
    "formNote": "Take these from the site licence or EIA. Each blast is judged by the limit in force on its day, so once a blast has been judged a limit stays as it was; a change is a new limit from a later day."
  },
  "lookups": {
    "bitSizes": {
      "add": "Add a bit size",
      "note": "The bit sizes offered on drilling, designs and the rig's consumables. A size in use on past drilling is retired rather than deleted; a retired one is no longer offered.",
      "neverDeleted": "A bit size is never deleted once added, because records point at it; take it out of use instead.",
      "takingOutOfUse": "Taking a bit size out of use keeps it on the records that have it and stops it being offered."
    },
    "holeTypes": {
      "add": "Add a hole type",
      "note": "Reports group drilling by hole type, and only types that count as production add to the production metres. Changing a category or that flag regroups past drilling too.",
      "neverDeleted": "A hole type is never deleted once added, because records point at it; take it out of use instead.",
      "takingOutOfUse": "Taking a hole type out of use keeps it on the records that have it and stops it being offered."
    },
    "blastTypes": {
      "add": "Add a blast type",
      "note": "The kinds of blast a pattern can be. Reports group blasts by the category, so changing it regroups past blasts too.",
      "neverDeleted": "A blast type is never deleted once added, because records point at it; take it out of use instead.",
      "takingOutOfUse": "Taking a blast type out of use keeps it on the records that have it and stops it being offered."
    },
    "removalReasons": {
      "add": "Add a removal reason",
      "note": "Why a bit, rod or hammer came off a rig, for the component register and its life analysis.",
      "neverDeleted": "A removal reason is never deleted once added, because records point at it; take it out of use instead.",
      "takingOutOfUse": "Taking a removal reason out of use keeps it on the records that have it and stops it being offered."
    },
    "saved": "{{name}} saved",
    "bitSizeLabel": "Label, as on the drilling screens",
    "diameterMm": "Diameter (mm)",
    "category": "Category",
    "orderInLists": "Order in lists",
    "countsAsProduction": "Counts as production drilling",
    "order": "Order",
    "wholeMineOnly": "These lists are the whole mine's, so only the mine's own admins change them.",
    "label": "Label",
    "diameter": "Diameter",
    "production": "Production",
    "counts": "Counts",
    "doesNotCount": "Does not count",
    "reason": "Reason"
  }
}
